import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { mapAgeRateDomainToViewModel } from 'projects/osn-shared/src/lib/utils/map-age-rate-to-view-model';
import { takeUntil } from 'rxjs';
import { AgeRate, Size } from '../../../common';
import { DestroyableBase, mapLanguageISOToLanguageName } from '../../utils';
import { episodePluralMapping } from '../../utils/episodePluralMapping';
import { seasonPluralMapping } from '../../utils/seasonPluralMapping';

@Component({
  selector: 'osn-shared-short-details',
  templateUrl: './short-details.component.html',
  styleUrls: ['./short-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShortDetailsComponent extends DestroyableBase implements OnInit {
  public readonly onLanguageChangeEvent$ = this.translateService.onLangChange;
  public seasonPluralMapping = seasonPluralMapping;
  public episodePluralMapping = episodePluralMapping;

  @Input() public lengthInSeconds: number;
  @Input() public numberOfSeasons: number;
  @Input() public numberOfEpisodes: number;
  @Input() public releaseYear: number;
  @Input() public ageRate: AgeRate;
  @Input() public size: Size = 'normal';
  @Input() public audioLanguages: string[] = [];
  @Input() public subtitleLanguages: string[] = [];
  @Input() public darkTextColor = false;
  @Input() public showLength = true;

  constructor(private readonly translateService: TranslateService) {
    super();
  }

  public ngOnInit(): void {
    this.translateService.onLangChange.pipe(takeUntil(this.onDestroy$)).subscribe(() => {});
  }

  public get ageRateText(): string {
    return mapAgeRateDomainToViewModel(this.ageRate);
  }

  public get subtitleTooltipText(): string {
    return `${this.subtitleLanguages.map((subtitle) => mapLanguageISOToLanguageName(subtitle)).join(', ')}`;
  }

  public get audioTooltipText(): string {
    return `${this.audioLanguages.map((audio) => mapLanguageISOToLanguageName(audio)).join(', ')}`;
  }
}
